export default [
  {
    description: 'Chat do Professor com a Turma',
    path: '/ferramentas/chat_professor_turma',
    name: 'chat_professor_turma', //SAEWEB NEW
    component: () => import('@/views/ferramentas/chat_professor_turma/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Chat do Professor com a Turma',
    path: '/ferramentas/chat_professor_turma',
    name: 'chat2_professor_turma',
    component: () => import('@/views/ferramentas/chat_professor_turma/Index.vue'),
    meta: {
      isLegacy: true, //remover quando não for utilizar pelo SAEWEB antigo. Daí, vai aplicar o template por padrão
      permissions: [

      ],
    },
    goesToMenu: true,
  },
]

